import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import SEO from "../../components/SEO";
import { login, isLoggedIn } from "../../lib/api";
import { TID, LOGO_URL } from "../../lib/brand";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  if (isLoggedIn()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Invalid credentials.");
    } finally { setBusy(false); }
  };

  return (
    <>
      <SEO title="Admin — ProForm" description="ProForm admin dashboard." />
      <section className="min-h-screen flex items-center py-20">
        <div className="wrap max-w-md mx-auto">
          <img src={LOGO_URL} alt="ProForm" className="h-16 mx-auto mb-8" />
          <h1 className="font-display uppercase text-4xl text-center mb-2">Admin Login</h1>
          <p className="label text-center mb-10">Owner &amp; team access</p>

          <form onSubmit={submit} data-testid={TID.admin.loginForm} className="space-y-5">
            <div>
              <label className="field-label" htmlFor="ae">Email</label>
              <input id="ae" data-testid={TID.admin.email} type="email" required className="field" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="field-label" htmlFor="ap">Password</label>
              <input id="ap" data-testid={TID.admin.password} type="password" required className="field" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            {err && <div className="text-proform-red text-sm">{err}</div>}
            <button data-testid={TID.admin.submit} className="btn btn-primary w-full justify-center" disabled={busy}>
              {busy ? "Signing in…" : "Sign in →"}
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
